import { Injectable, signal } from '@angular/core';
import { Territory } from '../core/classes/territory';

@Injectable({
  providedIn: 'root',
})
export class AppService {

  public selectedStates = signal<Territory[]>([]);
  public selectedYears = signal<number[]>([]);

  constructor() {
  }
}
